import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import Auth from './views/Auth.vue'
import Logout from './views/Logout.vue'

import Tickets from './views/Tickets.vue'
import Chats from './views/Chats.vue'
import Chatting from './views/Chatting'
import Users from './views/Users.vue'
import User from './views/User.vue'
import Pets from './views/Pets.vue'

import Articles from './views/Articles.vue'
import Blog from './views/Blog'
import ArticlesCountry from './views/Blog/views/country'
import ArticlesLang from './views/Blog/views/lang'
import ArticlesBlocks from './views/Blog/views/blocks'
import ArticlesPages from './views/Blog/views/pages'
import ArticlesBlockItem from './views/Blog/views/block-item'
import ArticlesPageItem from './views/Blog/views/page-item'
import ArticlesSubitem from './views/Blog/views/subitem'
import Article from './views/Article.vue'
import Stories from './views/Stories.vue'
import Story from './views/Story.vue'

import PetFood from './views/PetFood.vue'
import PetBreeds from './views/PetBreeds.vue'
import PetMap from './views/PetMap.vue'
import Promocodes from './views/PromocodeList.vue'
import Offers from './views/Offers.vue'
import PetMedia from './views/PetMedia.vue'
import Documents from './views/Documents.vue'
import Analytics from './views/Analytics.vue'
import Call from './views/Call.vue'
import BreedPredicts from './views/BreedPredicts.vue'
import Pushes from './views/Pushes.vue'

Vue.use(Router)

const generic = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/auth',
    name: 'auth',
    component: Auth
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout
  },
  {
    path: '*',
    redirect: '/'
  }
]

const support = [
  {
    path: '/tickets',
    name: 'tickets',
    component: Tickets,
    meta: { roles: ['god', 'support'], title: 'Тикеты' }
  },
  {
    path: '/chats',
    name: 'chats',
    component: Chats,
    meta: { roles: ['god', 'support', 'medic'], title: 'Чаты' }
  },
  {
    path: '/chats/:id',
    name: 'chat',
    component: Chats,
    props: true,
    meta: { roles: ['god', 'support', 'medic'] }
  },
  {
    path: '/chatting/:id',
    name: 'chatting',
    component: Chatting,
    meta: { roles: ['god', 'support', 'medic'] }
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
    meta: { roles: ['god', 'medic'], title: 'Клиенты' }
  },
  {
    path: '/users/:id',
    name: 'user',
    component: User,
    props: true,
    meta: { roles: ['god', 'medic'] }
  },
  {
    path: '/pets',
    name: 'pets',
    component: Pets,
    meta: { roles: ['god'], title: 'Питомцы' }
  }
]

const editor = [
  {
    path: '/articles',
    name: 'articles',
    component: Blog,
    meta: { roles: ['god', 'editor'], title: 'Статьи' },
    children: [
      {
        path: ':country',
        name: 'articles-country',
        component: ArticlesCountry,
        meta: { roles: ['god', 'editor'] },
        children: [
          {
            path: ':lang',
            name: 'articles-lang',
            component: ArticlesLang,
            meta: { roles: ['god', 'editor'] },
            redirect: {
              name: 'articles-pages'
            },
            children: [
              {
                path: 'blocks',
                name: 'articles-blocks',
                component: ArticlesBlocks,
                meta: { roles: ['god', 'editor'] },
                children: [
                  {
                    path: ':id',
                    name: 'articles-block-item',
                    component: ArticlesBlockItem,
                    meta: { roles: ['god', 'editor'] },
                    children: [
                      {
                        path: 'items/:itemId',
                        name: 'articles-block-subitem',
                        component: ArticlesSubitem,
                        meta: { roles: ['god', 'editor'] },
                        children: []
                      }
                    ]
                  }
                ]
              },
              {
                path: 'pages',
                name: 'articles-pages',
                component: ArticlesPages,
                meta: { roles: ['god', 'editor'] },
                children: [
                  {
                    path: ':id',
                    name: 'articles-page-item',
                    component: ArticlesPageItem,
                    meta: { roles: ['god', 'editor'] }
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/articles/:id',
    name: 'article',
    component: Article,
    meta: { roles: ['god', 'editor'] },
    props: true
  },
  {
    path: '/stories',
    name: 'stories',
    component: Stories,
    meta: { roles: ['god', 'editor'], title: 'Сторис' }
  },
  {
    path: '/stories/:id',
    name: 'story',
    component: Story,
    meta: { roles: ['god', 'editor'] },
    props: true
  }
]

const god = [
  // {
  // 	path: '/medics',
  // 	name: 'medics',
  // 	component: Medics,
  // 	meta: { roles: ['god'], title: 'Врачи' },
  // },
  {
    path: '/petfood',
    name: 'petfood',
    component: PetFood,
    meta: { roles: ['god'], title: 'База продуктов' }
  },
  {
    path: '/breeds',
    name: 'breeds',
    component: PetBreeds,
    meta: { roles: ['god'], title: 'Породы' }
  },
  {
    path: '/petmap',
    name: 'petmap',
    component: PetMap,
    meta: { roles: ['god'], title: 'Петфрендли' }
  },
  {
    path: '/promocodes',
    name: 'promocodes',
    component: Promocodes,
    meta: { roles: ['god'], title: 'Промокоды' }
  },
  {
    path: '/offers',
    name: 'offers',
    component: Offers,
    meta: { roles: ['god'], title: 'Офферы' }
  },
  {
    path: '/petmedia',
    name: 'petmedia',
    component: PetMedia,
    meta: { roles: ['god'], title: 'Медиа' }
  },
  {
    path: '/petmedia/:id',
    name: 'petmediaByUser',
    component: PetMedia,
    meta: { roles: ['god'] },
    props: true
  },
  {
    path: '/documents',
    name: 'documents',
    component: Documents,
    meta: { roles: ['god'], title: 'Документы' }
  },
  {
    path: '/documents/:id',
    name: 'documentsByUser',
    component: Documents,
    meta: { roles: ['god'] },
    props: true
  },
  // {
  // 	path: '/calls',
  // 	name: 'calls',
  // 	component: Calls,
  // 	meta: { roles: ['god', 'editor'], title: 'Консультации' },
  // },
  {
    path: '/calls/:id',
    name: 'call',
    component: Call,
    meta: { roles: ['god', 'editor'] },
    props: true
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: Analytics,
    meta: { roles: ['god'], title: 'Аналитика' }
  },
  {
    path: '/breed-predicts',
    name: 'breedPredicts',
    component: BreedPredicts,
    meta: { roles: ['god'], title: 'Сканер пород' }
  },
  {
    path: '/pushes',
    name: 'pushes',
    component: Pushes,
    meta: { roles: ['god'], title: 'Пуши' }
  }
]

export const routes = [...generic, ...support, ...editor, ...god]

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})
